import { LastPromptPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const LastPromptPersistenceProvider = createStaticContextProvider(
  LastPromptPersistenceContext,
  lazyValue(() =>
    import("./last-prompt-persistence").then(
      (module) => module.lastPromptPersistence,
    ),
  ),
);
